(function () {
  'use strict';

  angular.module('app').component('saleChannelsPage', saleChannelListCtrl());

  function saleChannelListCtrl() {
    return {
      bindings: {},
      controller: SaleChannelListsCtrl,
      controllerAs: 'vm',
      templateUrl: './app/ajs/sale-channels/sale-channels-page.component.html',
    };
  }

  SaleChannelListsCtrl.$inject = [
    'UtilService',
    'AbilityService',
    'SessionService',
    'SaleChannelService',
    'LanguageService',

    // Angular downgraded service
    'companyService',
  ];

  function SaleChannelListsCtrl(
    UtilService,
    AbilityService,
    SessionService,
    SaleChannelService,
    LanguageService,

    // Angular downgraded service
    companyService
  ) {
    const vm = this;

    // public properties
    // -----------------------
    vm.UtilService = new UtilService(vm);

    vm.permissions = {
      canCreate: AbilityService.can('create_salechannel_accountadmin'),
    };

    // public methods
    // -----------------------
    vm.createSaleChannel = function () {
      if (!vm.permissions.canCreate) return;

      var successCallback = function (selectedItem) {
        vm.saleChannels.push(selectedItem);
        vm.UtilService.itemListChanged(selectedItem.id);
      };

      SaleChannelService.openSaleChannelModal(
        {},
        'create',
        vm.defaultLanguage,
        vm.additionalLanguages,
        vm.company,
        successCallback
      );
    };

    vm.onShowSaleChannel = function (saleChannel, mode) {
      SaleChannelService.openSaleChannelModal(
        saleChannel,
        mode,
        vm.defaultLanguage,
        vm.additionalLanguages,
        vm.company
      );
    };

    // private methods
    // -----------------------
    getAdditionalLanguages();

    function getCompany() {
      vm.loadingItems = true;

      companyService
        .getCompany(SessionService.getSelectedAccountCompany().id, {
          skip_check_role: true,
          lang: vm.defaultLanguage,
        })
        .subscribe((response) => {
          vm.saleChannels = response.sale_channels || [];

          vm.totalItems = vm.saleChannels.length;

          vm.company = {
            id: response.id,
            users: response.users,
            websites: response.websites,
          };

          vm.loadingItems = false;
        });
    }

    function getAdditionalLanguages() {
      LanguageService.getLanguages({ skip_check_role: true }).then(function (data) {
        let languages = data.items;

        vm.defaultLanguage = languages.filter((language) => language.is_default)[0].lang;
        vm.additionalLanguages = languages.filter((language) => !language.is_default);

        getCompany();
      });
    }
  }
})();
